import React, { Fragment } from 'react'
import propTypes from 'prop-types'
import sccssIcon from '../../../images/new-error-icon.svg'
import Button from '../Button'

const SupplyErrorModal = ({
  size,
  center,
  msg,
  buttonText,
  t,
  handleClose,
  className,
  details,
}) => (
  <Fragment>
    <div id='supply-content-error-modal' className={`custom-modal ${size} ${className} custom-error-modal center`}>
      <img src={sccssIcon} />
      <h4 className='text-danger'>Falha</h4>
      <span className={`${center && ' text-center'} msg-error`}>{msg}</span>
      <span className='please-msg'>Por favor, tente novamente ou abra um chamado, indicando o motivo, no Service Now.</span>
      {details && (
        <span
          className={`no-margin-top error-modal-details${
            center && ' text-center'
          }`}
        >
          <span style={{fontWeight: 600}} className='no-margin details-msg'>Motivo: </span>
          <i className='details-msg'>{details}</i>
        </span>
      )}
      <Button
        className='btn btn-primary w-100 supply-error-modal-btn'
        text={buttonText || t('close')}
        onClick={() => handleClose()}
      />
    </div>
    <div className='bg' onClick={() => handleClose()} />
  </Fragment>
)

SupplyErrorModal.propTypes = {
  size: propTypes.string,
  handleClose: propTypes.func,
  msg: propTypes.string,
  t: propTypes.func,
  center: propTypes.bool,
  buttonText: propTypes.string,
  details: propTypes.string,
  className: propTypes.string,
}

export default SupplyErrorModal
